// When the desktop web app is opened on a small (mobile) screen, send the user
// to the mobile web app. Runs once on load, before React renders, so the
// desktop UI never paints on a phone.

// Matches the `sm` breakpoint used by useIsMobile (helperFunctions/pageSize).
const MOBILE_MAX_WIDTH = 640

const isMobileScreen = (): boolean =>
    typeof window.matchMedia === 'function'
        ? window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
        : window.innerWidth <= MOBILE_MAX_WIDTH

// Resolve the mobile web app URL for the current environment, or null when
// there's no mobile target (so we shouldn't redirect).
const mobileAppUrl = (): string | null => {
    const { hostname, protocol, port } = window.location

    // Local dev: the web app runs on :3010, the mobile web dev server on :3011.
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        if (port === '3011') return null // already on the mobile app
        return `${protocol}//${hostname}:3011/`
    }

    // Deployed: app.buyerflo.com.au -> mobile.buyerflo.com.au (and uat).
    if (hostname.startsWith('app.')) {
        return `${protocol}//mobile.${hostname.slice('app.'.length)}/`
    }

    // Any other host (previews, etc.) has no mobile equivalent — stay put.
    return null
}

export const redirectToMobileApp = (): void => {
    // Escape hatch: ?desktop keeps you on the desktop app (e.g. if the mobile
    // app misbehaves). Lets a user who was redirected get back.
    if (new URLSearchParams(window.location.search).has('desktop')) return

    if (!isMobileScreen()) return

    const target = mobileAppUrl()
    if (target) window.location.replace(target)
}
